<template>
    <v-container class="pt-xs-0" >
        <v-container fluid v-if="loading">
            <v-layout row wrap>
                <v-flex xs12>
                    <div class="loader"></div>
                </v-flex>
            </v-layout>
        </v-container>
        <div v-for="item in this.FILTERED_BIOGRAPHY" :key="item.heading">
            <h2>{{item.heading}}</h2>
            <ul class="pl-xs-1">
                <li v-for="(bio,index) in item.biography" :key="`bio-${index}`">

                    <span @click="handleParliamentaryServiceClick" v-if="bio.id == 1 && bio.typeId != 2 && bio.typeId != 4 && bio.typeId != 5 
                        && bio.typeId != 11 && bio.typeId != 22 && bio.typeId != 99  && bio.typeId != 111
                        && bio.typeId != 999 && bio.typeId != 105 && bio.typeId != 104" v-html="bio.record[0]">
                    </span>

                    <v-template v-if="bio.typeId == 104" v-html="bio.record[0]"></v-template>

                    <span v-if="bio.typeId == 105">
                        <router-link v-if="bio.record[0].indexOf('Gender') > -1"  class="handbook-link_link" 
                            :to="{ name: $store.state.ROUTE_GENDERCOMPOSITIONOFPARLIAMENT }">
                            {{bio.record[0]}}
                        </router-link>
                        <router-link v-else-if="bio.record[2] === 'Family'"  class="handbook-link_link" 
                            :to="{ name: $store.state.ROUTE_PARLIAMENTARIAN, params: { PHID: bio.record[1] } }">
                            {{bio.record[0]}}
                        </router-link>
                        <span v-else>{{bio.record[0]}}</span>
                    </span>

                    <router-link v-if="bio.id == 1 && bio.typeId == 4"  class="handbook-link_link" :to="{ name: $store.state.ROUTE_ELECTORATE, params: { Electorate: bio.record[0], State: bio.record[1]  }}">
                        {{bio.record[0]}}, {{bio.record[1]}}
                    </router-link>
<!-- 
                    <router-link v-if="bio.id == 1 && bio.typeId == 11"  class="handbook-link_link" :to="{ name: $store.state.ROUTE_PARTY, params: { Party: bio.record[0]}}">
                        {{bio.record[0]}}{{bio.record[3]}}
                    </router-link> -->

                    <router-link v-if="bio.id == 1 && bio.typeId == 5 && bio.record[0]"  class="handbook-link_link" :to="{ name: $store.state.ROUTE_MINISTRY, params: { MID: bio.record[0]}}">
                        {{bio.record[1]}}{{bio.record[2]}}{{bio.record[3]}}{{bio.record[4]}}{{bio.record[5]}}
                    </router-link>
                    <router-link v-if="bio.id == 1 && bio.typeId == 5 && !(bio.record[0])" class="handbook-link_link" :to="{ name: $store.state.ROUTE_MINISTRIES}">
                        {{bio.record[1]}}{{bio.record[2]}}{{bio.record[3]}}{{bio.record[4]}}{{bio.record[5]}}
                    </router-link>

                    <router-link v-if="bio.id == 1 && bio.typeId == 22 && bio.record[0]"  class="handbook-link_link" :to="{ name: $store.state.ROUTE_SHADOWMINISTRY, params: { SMID: bio.record[0]}}">
                        {{bio.record[1]}}{{bio.record[2]}}{{bio.record[3]}}{{bio.record[4]}}{{bio.record[5]}}
                    </router-link>
                    <router-link v-if="bio.id == 1 && bio.typeId == 22 && !(bio.record[0])" class="handbook-link_link" :to="{ name: $store.state.ROUTE_SHADOWMINISTRIES}">
                        {{bio.record[1]}}{{bio.record[2]}}{{bio.record[3]}}{{bio.record[4]}}{{bio.record[5]}}
                    </router-link>

                    <h3 v-if="bio.typeId == 999 && bio.committeeRecordArray.length > 0">
                        {{bio.type.replace('House', 'House of Representatives')}}
                    </h3>
                    <ul v-if="bio.typeId == 999 && bio.committeeRecordArray.length > 0">
                        <li v-for="commService in bio.committeeRecordArray" :key="commService.ParentCommitteeMemberID">
                            <router-link class="handbook-link_link" :to="{ name: $store.state.ROUTE_COMMITTEE,
                             params: { CID: commService.CID}}">
                                <h4>{{ commService.Name }}</h4> 
                            </router-link>
                            <ul v-if="commService.PositionString !== null">
                                <li v-for="service in commService.PositionString.split(', ')">
                                    <router-link class="handbook-link_link" :to="{ name: $store.state.ROUTE_COMMITTEE,
                                        params: { CID: commService.CID}}">{{ service}}    </router-link>
                                </li>
                            </ul>
                            
                        </li>
                    </ul>
                    <v-template v-if="bio.typeId == 111">
                        <router-link  class="handbook-link_link" :to="{ name: $store.state.ROUTE_PARTY, params: { Party: bio.record[0] }}">
                            {{bio.record[1]}}. {{bio.record[2]}}
                        </router-link>
                    </v-template>
                    
                </li>
            </ul>
           
            <ul>
                <li v-for="commService in item.committees" :key="commService.Type">
                    <h3>{{commService.Type}}</h3>
                    <ul>
                        <li v-for="(bio,index) in commService.biography" :key="`bio-${index}`">
                            <router-link v-if="bio.id == 1 && bio.typeId == 2"  class="handbook-link_link" :to="{ name: $store.state.ROUTE_COMMITTEE, params: { Type: bio.record[0], Service: bio.record[1]}, query: {parliament: GET_PARLIAMENT_FROM_DATES(bio.record[4], bio.record[5])}}">
                                {{bio.record[1]}}{{bio.record[3]}}{{bio.record[2] ? ` (${bio.record[2]}:${bio.record[6].substring(1, bio.record[6].length - 1).replace('Served: ', '')})` : ''}}
                            </router-link>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
        <h3 class="ml-4 pt-1" v-if="(FILTERED_PARLIAMENTARIAN.DateOfDeath || this.FILTERED_PARLIAMENTARIAN.PlaceOfDeath) && speeches.filter(s => s.Type == 3).length > 0">Condolence motions</h3>
        <ul class="ml-3" v-if="(FILTERED_PARLIAMENTARIAN.DateOfDeath || this.FILTERED_PARLIAMENTARIAN.PlaceOfDeath) && speeches.filter(s => s.Type == 3).length > 0">
            <li  v-for="(speech, index) in speeches.filter(s => s.Type == 3)" :key="`condolence-${index}`" >
                <a class="handbook-link_link" :href="speech.Link" target="_blank">{{ speech.Title }}</a>
            </li>
        </ul>
        <div v-if="!loadingText && (data.AdbLink || data.Biography)">
            <h2>Biography</h2>
            <a v-if="data.AdbLink" :href="data.AdbLink" target="_blank">
                Australian Dictionary of Biography
            </a>
            <div v-if="data.Biography">
                <br v-if="data.AdbLink"/>
                <div v-html="data.Biography"></div>
            </div>
        </div>
    </v-container>
</template>

<script>
    import axios from 'axios'
    window.Handbook = window.Handbook || {}
    const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
    axios.defaults.baseURL = apiUri;

    export default {

        props: {
            FILTERED_PARLIAMENTARIAN: {
                type: Object,
                required: true
            },
            PHID: {
                type: String,
                required: true,
                value: 'EZ5'
            },
            STATE: {
                type: String,
                required: true,
            },
            Electorate: {
                type: String,
                required: false,
            }
        },

        created() {
            this.initialiseData()
            this.initialiseBiography();
        },

        data() {
            return {
                data: null,
                loading: true,
                loadingText: true,
                recordsOfService: [],
                // used for position no
                senators: [],
                members: [],
                ministries: [],
                shadowMinistries: [],
                committeeService: [],
                committeeTypes: [],
                speeches: [],
                ministerialStatements: [],
                partyService: [],
                familyRelationships: []
            }
        },

        methods: {
            initialiseData() {
            this.loadingText = true;
            const url = `Parliamentarian/GetBiography?id=${this.PHID}`;
            axios.get(`api/${url}`)
                .then(response => {
                    this.data = response.data;
                    this.personFk = response.data.personFK;
                    this.familyRelationships = response.data.FamilyRelationship
                    this.loadingText = false;

                    const speechesUrl = `Parliamentarian/GetSpeeches?Id=${this.data.PersonFk}`;
                    axios.get(`api/${speechesUrl}`)
                    .then(response => {
                        this.speeches = response.data;
                    });

                    const ministerialStatementsUrl = `Parliamentarian/GetMinisterialStatements?Id=${this.data.PersonFk}`;
                    axios.get(`api/${ministerialStatementsUrl}`)
                    .then(response => {
                        this.ministerialStatements = response.data;
                    });      

                });
            },
            initialiseBiography() {
                this.loading = true;

                const url = `recordsofservice?$filter=PHID%20eq%20%27${this.PHID}%27`;
                // used for calculating position number
                this.FILTERED_PARLIAMENTARIAN.RepresentedStates.forEach(s => {
                    const senatorsUrl = `individuals?$orderby=ElectedSenatorNo asc&$filter=MPorSenator/any(m:m eq 'Senator') and RepresentedStates/any(s:s eq '${s}')&$select=PHID`;
                    axios.get(`api/${senatorsUrl}`)
                        .then(response => {
                            this.senators = response.data.value;
                        });
                })
                this.FILTERED_PARLIAMENTARIAN.RepresentedElectorates.forEach(e => {
                    const electorate = e.replace("'", "''");
                    const membersUrl = `individuals?$orderby=ElectedMemberNo asc&$filter=MPorSenator/any(m:m eq 'Member') and RepresentedElectorates/any(e:e eq '${electorate}')&$select=PHID`;
                    axios.get(`api/${membersUrl}`)
                        .then(response => {
                            this.members.push(Object.create({}, { electorate: { value: electorate }, data: {value: response.data.value} }));
                        });
                })
                const ministriesUrl = 'ministries?Select=MID,DateStart,DateEnd';
                axios.get(`api/${ministriesUrl}`)
                    .then(response => {
                        this.ministries = response.data.value;
                    });

                const shadowMinistriesUrl = 'shadowministries?Select=SMID,DateStart,DateEnd';
                axios.get(`api/${shadowMinistriesUrl}`)
                    .then(response => {
                        this.shadowMinistries = response.data.value;
                    });
                
                axios.get(`api/${url}`)
                    .then(response => {
                        this.recordsOfService = response.data.value;

                        axios.get(`api/CommitteeServiceRecords/BiographyService/${this.PHID}`)
                            .then(response => {
                                this.committeeService = response.data;
                                
                                const arrayUniqueByKey = [...new Set(this.committeeService.map(item => item.Type))];
                                this.committeeTypes = arrayUniqueByKey;

                                if (response.data.length > 0) {
                                    var first = this.committeeService[0];
                                    this.recordsOfService.push({ OBY: first.OBY, ROSTypeID: 999, PHID: first.PHID})
                                }
                            });

                        const partyUrl = `PartiesData/GetPartyServiceForParliamentarian?personId=${this.PHID}`;
                        axios.get(`api/${partyUrl}`)
                            .then(response => {
                                this.partyService = response.data;
                               
                                if (response.data != null) {
                                    this.recordsOfService.push({ OBY: 21, ROSTypeID: 111, PHID: this.partyService.PHID})
                                }
                            });

                        this.loading = false;
                    });

               
            },
            handleParliamentaryServiceClick(e) {
                if (e.target.tagName === 'A') {
                    e.preventDefault();
                    const year = parseInt(e.target.innerText);
                    if (e.target.classList.contains('senator_link')) {
                        const stateService = this.parliamentaryService
                            .find(e => e.DateStart1.includes(year) || 
                            e.DateStart1.includes(year + 1) ||
                            (e.DateEnd1 && (e.DateEnd1.includes(year) || e.DateEnd1.includes(year + 1))));

                        if (stateService) {
                            // const date = `${year}-1-1`;
                            this.$router.push({ name: 'SenateResultByCandidate', params: { year, state: stateService.ValueAbbrev1.toUpperCase() }});
                            // const url = `Elections/ElectionId?date=${date}`;
                            // axios.get(`api/${url}`)
                            //     .then(response => {
                            //         this.$router.push({ name: 'SenateResultByCandidate', params: { year, electionId: response.data, state: stateService.ValueAbbrev1 }});
                            //     });
                        }
                        } else {
                            const electorateService = this.FILTERED_PARLIAMENTARIAN
                                .ElectorateService
                                .find(e => e.ServiceStart.includes(year) || 
                                    (e.ServiceEnd && e.ServiceEnd.includes(year)
                                    )
                                    );

                            if (electorateService) {
                                const date = `${year}-1-1`;
                                const url = `Elections/ElectionId?date=${date}`;
                                axios.get(`api/${url}`)
                                    .then(response => {
                                        this.$router.push({ name: 'DivisionalResult', params: { year, electionId: response.data, division: electorateService.Electorate }});
                                    });
                            }
                        }
                }
            },
            CREATEBIO(Data) {
                // Creating object properties using bracket or dot notation
                let ARRAY_BIO = [];
                let headingStart = ''
                let headingEnd = ''
                let heading = ''
                let record = ''
                let senateStates = []
                let houseElectorates = []

                String.prototype.trimEndChar = function (char) {
                    if (this.toString().endsWith(char)) {
                        return this.toString().substring(0, this.toString().length - 1).trimEndChar(char);
                    } else {
                        return this.toString();
                    }
                }
                

                for (let index = 0; index < Data.length; index++) {
                    switch (Data[index].ROSTypeID) {
                        case 1:
                            heading = 'Acting Ministry Appointments'
                            record = [this.STRING_COALESCE(Data[index].Text1).trimEndChar('.') + this.DATE_FROMTO(Data[index].DateStart1, Data[index].DateEnd1)]
                            break;
                        case 2:
                            heading = 'Committee Service'
                            record = [Data[index].Value1, Data[index].Value2, Data[index].Value3.trimEndChar('.'), this.DATE_FROMTO(Data[index].DateStart1, Data[index].DateEnd1), Data[index].DateStart1, Data[index].DateEnd1, this.DATE_FROMTO(Data[index].DateStart2, Data[index].DateEnd2), Data[index].DateStart2, Data[index].DateEnd2]
                            break;
                        case 999:
                            heading = 'Committee Service'
                            record = ''
                            break;
                        case 111:
                            heading = 'Parties Represented'
                            record = ''
                            break;
                        case 3:
                            heading = 'Conferences, Delegations and Visits'
                            record = [this.STRING_COALESCE(Data[index].Text1).trimEndChar('.') + '.']
                            break;
                        case 4:
                            heading = 'Electorate'
                            record = [this.STRING_COALESCE(Data[index].Value1.trim()), this.convertStateAbbreviationToState(Data[index].ValueAbbrev1)]
                            break;
                        case 5:
                            heading = 'Ministry Appointments'
                            record = [this.GET_MINISTRY_FROM_DATES(Data[index].DateStart1, Data[index].DateEnd1), this.STRING_COALESCE(Data[index].Value1), this.STRING_COALESCE(Data[index].Value2, ' '), this.STRING_COALESCE(Data[index].Text1, ' '), this.STRING_COALESCE(Data[index].Value3, ' ').trimEndChar('.'), this.DATE_FROMTO(Data[index].DateStart1, Data[index].DateEnd1)]
                            break;
                        case 6:
                            heading = 'Parliamentary Appointments'
                            record = [this.STRING_COALESCE(Data[index].Text1).trimEndChar('.') + this.DATE_FROMTO(Data[index].DateStart1, Data[index].DateEnd1)]
                            break;
                        case 7:
                            heading = 'Parliamentary Party Positions'
                            record = [this.STRING_COALESCE(Data[index].Value1) + this.STRING_COALESCE(Data[index].Value2, ' ') + this.STRING_COALESCE(Data[index].Value3, ' ') + Data[index].Text1.trimEndChar('.') + this.DATE_FROMTO(Data[index].DateStart1, Data[index].DateEnd1)]
                            break;
                        case 8:
                            heading = 'Parliamentary Positions'
                            record = [this.STRING_COALESCE(Data[index].Value1) + this.STRING_COALESCE(Data[index].Text1, ' ').trimEndChar('.') + this.DATE_FROMTO(Data[index].DateStart1, Data[index].DateEnd1)]
                            break;
                        case 9:
                            heading = 'Parliamentary Service'
                            record = [this.STRING_COALESCE(Data[index].Value1) + this.STRING_COALESCE(Data[index].Value2, ' ') + this.STRING_COALESCE(Data[index].Text1, ' ').trimEndChar('.') + this.DATE_FROMTO(Data[index].DateStart1, Data[index].DateEnd1), Data[index].DateStart1, Data[index].DateEnd1]
                            break;
                        case 10:
                            heading = 'Party Positions'
                            record = [this.STRING_COALESCE(Data[index].Value1) + this.STRING_COALESCE(Data[index].Text1, ' ').trimEndChar('.') + this.DATE_FROMTO(Data[index].DateStart1, Data[index].DateEnd1)]
                            break;
                        case 11:
                            heading = 'Parties Represented'
                            record = [this.STRING_COALESCE(Data[index].Value1), Data[index].DateStart1, Data[index].DateEnd1]
                            break;
                        case 12:
                            heading = 'State Government Service'
                            record = [this.STRING_COALESCE(Data[index].Value1) + this.STRING_COALESCE(Data[index].Text1, ' ') + this.STRING_COALESCE(Data[index].Text2, ' ').trimEndChar('.') + this.DATE_FROMTO(Data[index].DateStart1, Data[index].DateEnd1)]
                            break;
                        case 13:
                            heading = 'Decorations'
                            record = [this.STRING_COALESCE(Data[index].Text1, ' ').trimEndChar('.') + '.']
                            break;
                        case 14:
                            heading = 'Honours'
                            record = [this.STRING_COALESCE(Data[index].Text1, ' ').trimEndChar('.') + '.']
                            break;
                        case 15:
                            heading = 'Local Government Service'
                            record = [Data[index].Text1 + this.STRING_COALESCE(Data[index].Value1, ' ').trimEndChar('.') + this.DATE_FROMTO(Data[index].DateStart1, Data[index].DateEnd1)]
                            break;
                        case 16:
                            heading = 'Military Service'
                            record = [this.STRING_COALESCE(Data[index].Text1, ' ').trimEndChar('.') + '.']
                            break;
                        case 17:
                            heading = 'Miscellaneous Information'
                            record = [this.STRING_COALESCE(Data[index].Text1, ' ').trimEndChar('.') + this.DATE_FROMTO(Data[index].DateStart1, Data[index].DateEnd1)]
                            break;
                        case 18:
                            heading = 'Occupations'
                            record = [this.STRING_COALESCE(Data[index].Text1, ' ').trimEndChar('.') + this.DATE_FROMTO(Data[index].DateStart1, Data[index].DateEnd1)]
                            break;
                        case 19:
                            heading = 'Other Positions'
                            record = [this.STRING_COALESCE(Data[index].Text1, ' ').trimEndChar('.') + this.DATE_FROMTO(Data[index].DateStart1, Data[index].DateEnd1)]
                            break;
                        case 20:
                            heading = 'Publications'
                            record = [this.STRING_COALESCE(Data[index].Text1) + this.STRING_COALESCE(Data[index].Text2, ' ') + this.STRING_COALESCE(Data[index].Text3, ' ').trimEndChar('.') + ' ' + this.$moment(Data[index].DateStart1).year() + '.']
                            break;
                        case 21:
                            heading = 'Qualifications'
                            record = [this.STRING_COALESCE(Data[index].Value2) + this.STRING_COALESCE(Data[index].Value3, ', ').trimEndChar('.') + (this.DATE_COALESCE(Data[index].DateStart1) !== '' ? ` ${this.$moment(Data[index].DateStart1).year()}.` : '.')];
                            break;
                        case 22:
                            heading = 'Shadow Ministry Appointments'
                            record = [this.GET_SHADOWMINISTRY_FROM_DATES(Data[index].DateStart1, Data[index].DateEnd1), this.STRING_COALESCE(Data[index].Value1), this.STRING_COALESCE(Data[index].Value2, ' '), this.STRING_COALESCE(Data[index].Text1, ' '), this.STRING_COALESCE(Data[index].Value3, ' ').trimEndChar('.'), this.DATE_FROMTO(Data[index].DateStart1, Data[index].DateEnd1)]
                            break;
                        default:
                            heading = 'DEFAULT'
                            record = [this.STRING_COALESCE(Data[index].Value1) + this.STRING_COALESCE(Data[index].Value2, ' ') + this.STRING_COALESCE(Data[index].Value3, ' ')]
                            break;
                    }

                    if (Data[index].ROSTypeID !== 3 && Data[index].ROSTypeID !== 999 && Data[index].ROSTypeID !== 2 && Data[index].ROSTypeID !== 11) { // don't show delegations
                        headingStart = Data[index].OBY

                        if (headingStart !== headingEnd) {
                            ARRAY_BIO.push({ rosTypeId: Data[index].ROSTypeID, type: 0, heading: heading, biography: [] });
                        }
                        headingEnd = Data[index].OBY

                        var records = ARRAY_BIO.find(i => i.rosTypeId == Data[index].ROSTypeID);
                        if (records && records.biography) {
                            if (records.rosTypeId == 2) { //committee service
                                if (!records.committees) {
                                    records.committees = [];
                                }
                                var committeeHeading = records.committees.find(c => c.Type === record[0]);
                                if (!committeeHeading) {
                                    records.committees.push({ Type: record[0], biography: [] });
                                    committeeHeading = records.committees.find(c => c.Type === record[0]);
                                }
                                committeeHeading.biography.push({ id: 1, typeId: Data[index].ROSTypeID, record: record });
                            } else if (records.rosTypeId !== 9) {
                                records.biography.push({ id: 1, typeId: Data[index].ROSTypeID, record: record });
                            }
                        }
                    }

                    if (Data[index].ROSTypeID === 999) {
                        if (this.committeeService.length > 0)
                        {
                            ARRAY_BIO.push({ rosTypeId: 999, type: 0, heading: "Committee Service", biography: [] });
                            var committeeRecords = ARRAY_BIO.find(i => i.rosTypeId == 999);

                            var committeeTypeArray = [];

                            for (let i = 0; i < this.committeeTypes.length; i++) {
                                var committeeRecordArray = [];
                                var OBY = 0;
                                var type = this.committeeTypes[i];

                                if (type.indexOf('Senate Standing') > -1){
                                    OBY = 1;
                                } 
                                else if (type.indexOf('Senate Legislative') > -1){
                                    OBY = 2;
                                }
                                else if (type.indexOf('Senate Estimates') > -1){
                                    OBY = 3;
                                }
                                else if (type.indexOf('Senate Select') > -1){
                                    OBY = 4;
                                }
                                else if (type.indexOf('House Standing') > -1){
                                    OBY = 5;
                                } 
                                else if (type.indexOf('House Select') > -1){
                                    OBY = 6;
                                }
                                else if (type.indexOf('Joint Standing') > -1){
                                    OBY = 7;
                                }
                                else if (type.indexOf('Joint Statutory') > -1){
                                    OBY = 8;
                                }
                                else if (type.indexOf('Joint Select') > -1){
                                    OBY = 9;
                                }

                                for (let x = 0; x < this.committeeService.length; x++) {
                                    if (this.committeeService[x].Type == this.committeeTypes[i]){
                                        committeeRecordArray.push(this.committeeService[x]);
                                    }
                                }

                                committeeRecordArray = committeeRecordArray.sort((a, b) => a.Name < b.Name ? -1 : (a.Name === b.Name ? 0 : 1));
                                
                                committeeTypeArray.push({ id: 1, OBY: OBY, typeId: 999, type: this.committeeTypes[i], record:[], committeeRecordArray });
                            }

                            committeeTypeArray = committeeTypeArray.sort((a, b) => a.OBY > b.OBY ? -1 : (a.OBY === b.OBY ? 0 : 1));

                            committeeRecords.biography = committeeTypeArray;
                        }
                    }

                    //parties
                    if (Data[index].ROSTypeID === 111) {
                        if (this.partyService.PartyRecords.length > 0)
                        {
                            var partyService = ARRAY_BIO.find(i => i.rosTypeId == 111);

                            var partyServiceArray = [];

                            for (let i = 0; i < this.partyService.PartyRecords.length; i++) {
                                
                                var serviceString = "";
                                for (let j = 0; j < this.partyService.PartyRecords[i].PartyRecords.length; j++) {
                                    serviceString += "Served: " + this.partyService.PartyRecords[i].PartyRecords[j].StartDateString 
                                    + " to " + this.partyService.PartyRecords[i].PartyRecords[j].EndDateString + ". ";
                                }

                                var partyRecord = [this.partyService.PartyRecords[i].PartyID.toString(), this.partyService.PartyRecords[i].PartyName, serviceString];
                                partyServiceArray.push({ id: 1, OBY: i, typeId: 111, record: partyRecord});
                            }

                            partyServiceArray = partyServiceArray.sort((a, b) => a.OBY > b.OBY ? -1 : (a.OBY === b.OBY ? 0 : 1));

                            partyService.biography = partyServiceArray;
                        }
                    }

                    // used to calculate position number
                    if (Data[index].ROSTypeID === 9) { //Parliamentary Service
                        if (Data[index].MpOrSenator === 'Senator' && senateStates.every(b => b.record[0] !== Data[index].Value1)) {
                            let parls = this.senators;
                            let statePos = 0;
                            for (let i = 0; i < parls.length && statePos === 0; i++) {
                                if (parls[i].PHID === this.FILTERED_PARLIAMENTARIAN.PHID) {
                                    statePos = this.numberToOrdinal(i + 1);
                                }
                            }
                            senateStates.push({ id: 1, typeId: 99, record: [Data[index].Value1, statePos] });
                        }

                        if (Data[index].MpOrSenator === 'Member' && houseElectorates.every(b => b.record[0] !== Data[index].Value2)) {
                            const filteredParls = this.members;
                            let electoratePos = 0;
                            for (let j = 0; j < filteredParls.length; j++) {
                                if (filteredParls[j].electorate == Data[index].Value2){
                                    for (let i = 0; i < filteredParls[j].data.length && electoratePos === 0; i++) {
                                        if (filteredParls[j].data[i].PHID === this.FILTERED_PARLIAMENTARIAN.PHID) {
                                            electoratePos = this.numberToOrdinal(i + 1);
                                        }
                                    }
                                }
                            }
                            
                            houseElectorates.push({ id: 1, typeId: 99, record: [Data[index].Value2, Data[index].Value1, electoratePos] });
                        }
                    }
                }

                for (let i = 0; i < ARRAY_BIO.length; i++) {
                    ARRAY_BIO[i].biography.reverse();
                }

                for (let i = 0; i < ARRAY_BIO.length; i++) {
                    if (ARRAY_BIO[i].rosTypeId === 2) {
                        ARRAY_BIO[i].committees.sort((a, b) => a.Type < b.Type ? -1 : (a.Type === b.Type ? 0 : 1));
                        for (let j = 0; j < ARRAY_BIO[i].committees.length; j++) {
                            ARRAY_BIO[i].committees[j].biography.reverse();
                        }
                    }
                }

                // handle Parliamentary Service specially, concatenate things together.
                const parliamentaryService = [...Data.filter(d => d.ROSTypeID === 9)].reverse();

                // start with the first record
                // have to also have an option without links
                let reelectedCounter = 0;
                let cleanRecord = '';
                parliamentaryService.forEach((p, i) => {
                    if (i === 0) {
                        record = parliamentaryService[0].Text1;
                        cleanRecord = record;
                        // only replace if Reps
                        if (record.includes('House of Representatives')) {
                            record = record.replaceAll(/\d{4}/g, match => `<a class="handbook-link_link">${match}</a>`)
                        }
                    }
                    else {
                        let stuffer = ' ';
                        let ending = '';
                        // if last one, use and instead.
                        let textToConcatenate = p.Text1;
                        let nextRecord = null;
                        if (i < parliamentaryService.length - 1) {
                            nextRecord = parliamentaryService[i + 1];
                        }
                        // if releected, concatenate on
                        if (p.Text1.includes('Elected to')) {
                            reelectedCounter = 0;
                        }
                        else if (p.Text1.includes('Re-elected')) {
                            reelectedCounter++;
                            if (reelectedCounter > 1) {
                                stuffer = ', ';
                                textToConcatenate = textToConcatenate.replace('Re-elected', '')
                            }
                            // if last one in a sequence.
                            if (i === parliamentaryService.length - 1 || nextRecord.Text1.includes('Elected to')) {
                                if (reelectedCounter > 1) {
                                    stuffer = ' and ';
                                }
                                if (textToConcatenate[textToConcatenate.length - 1] !== '.') {
                                    ending = '.';
                                }
                            }
                        }
                        let cleanText = textToConcatenate;
                        if (p.MpOrSenator === 'Senator') {
                            textToConcatenate = textToConcatenate.replaceAll(/\b(?<!\.)\d{4}\b/g, match => `<a class="handbook-link_link senator_link">${match}</a>`)
                        } else {
                            textToConcatenate = textToConcatenate.replaceAll(/\b(?<!\.)\d{4}\b/g, match => `<a class="handbook-link_link member_link">${match}</a>`)
                        }
                        record += (stuffer + textToConcatenate + ending);
                        cleanRecord += (stuffer + cleanText + ending);
                    }
                });


                // go through each record, and keep concatenating

                if (record.length > 0) {
                    var parlService = ARRAY_BIO.find(i => i.rosTypeId == 9);
                    if (parlService && parlService.biography) {
                        parlService.biography.push({ id: 1, typeId: 9, record: [record], cleanRecord: [cleanRecord] });
                    }
                }

                // add  speeches records  as not maintained in ROS
                
                ARRAY_BIO.push({ rosTypeId: 104, type: 0, heading: "Speeches", biography: [] });
                var bioSpeeches = ARRAY_BIO.find(i => i.rosTypeId == 104);

                if (this.speeches.filter(s => s.Type != 3).length > 0) {
                    for (let x = 0; x < this.speeches.filter(s => s.Type != 3).length; x++) {
                        var content = "<a target='_blank' class='handbook-link_link' href='" + this.speeches.filter(s => s.Type != 3)[x].Link + "' >" + this.speeches.filter(s => s.Type != 3)[x].Title + "</a>";
                        bioSpeeches.biography.push({ id: 1, typeId: 104, record: [content] });
                    }
                }
                var allSpeechesLink = "<a class='handbook-link_link' target='_blank' href='https://parlinfo.aph.gov.au/parlInfo/search/summary/summary.w3p;" 
                + "query=Dataset%3Ahansardr,hansards,hansardr80,hansards80%20((SpeakerId%3A" 
                + this.PHID + "));resCount=Default'>Browse all speeches on ParlInfo</a>";

                bioSpeeches.biography.push({ id: 1, typeId: 104, record: [allSpeechesLink] });

                // add ministerial statement records as not maintained in ROS                
                var bioMinisterialStatements = { rosTypeId: 104, type: 0, heading: "Ministerial Statements", biography: [] }

                if (this.ministerialStatements.length > 0) {
                    for (let x = 0; x < this.ministerialStatements.length; x++) {
                        const content = "<a target='_blank' class='handbook-link_link' href='" + this.ministerialStatements[x].Link + "' >" + this.ministerialStatements[x].Title 
                        + ` (${this.$moment(this.ministerialStatements[x].Date).format('DD.MM.YYYY')})` + "</a>";
                        bioMinisterialStatements.biography.push({ id: 1, typeId: 104, record: [content] });
                    }
                    ARRAY_BIO.push(bioMinisterialStatements);
                }                                
               
                // add  personal records fromthe Individualrecord as not maintained in ROS
                ARRAY_BIO.push({ rosTypeId: 105, type: 0, heading: "Personal", biography: [] });
                var personalRecords = ARRAY_BIO.find(i => i.rosTypeId == 105);

                record = this.STRING_COALESCE(this.FILTERED_PARLIAMENTARIAN.Gender, 'Gender: ');
                if (record.length > 0) {
                    personalRecords.biography.push({ id: 1, typeId: 105, record: [record] });
                }

                if (this.FILTERED_PARLIAMENTARIAN.FirstNations){
                    record = 'Aboriginal and/or Torres Strait Islander: Yes ' + (this.FILTERED_PARLIAMENTARIAN.FirstNationsText != null && this.FILTERED_PARLIAMENTARIAN.FirstNationsText != '' ? '- ' + this.FILTERED_PARLIAMENTARIAN.FirstNationsText : '');
                    if (record.length > 0) {
                        personalRecords.biography.push({ id: 1, typeId: 105, record: [record] });
                    }
                }
                
                record = this.STRING_COALESCE(this.FILTERED_PARLIAMENTARIAN.PreferredName, 'Preferred Name: ');
                if (record.length > 0) {
                    personalRecords.biography.push({ id: 1, typeId: 105, record: [record] });
                }

                record = this.STRING_COALESCE(this.FILTERED_PARLIAMENTARIAN.SecondarySchool, 'Secondary School: ');
                if (record.length > 0) {
                    personalRecords.biography.push({ id: 1, typeId: 105, record: [record] });
                }

                if (this.FILTERED_PARLIAMENTARIAN.MaritalStatus != 'Unknown'){
                    record = this.STRING_COALESCE(this.FILTERED_PARLIAMENTARIAN.MaritalStatus, 'Marital Status: ')
                    if (record.length > 0) {
                        personalRecords.biography.push({ id: 1, typeId: 105, record: [record] });
                    }
                }
                

                let inCurrentParliament = this.FILTERED_PARLIAMENTARIAN.InCurrentParliament.toUpperCase() == "TRUE";
                record = inCurrentParliament ? 'In current Parliament' : '';
                if (inCurrentParliament) {
                    personalRecords.biography.push({ id: 1, typeId: 105, record: [record] });
                }

                // if (ARRAY_BIO && ARRAY_BIO.find(b => b.rosTypeId === 11) && ARRAY_BIO.find(b => b.rosTypeId === 9)) {
                //     let partyRepresentation = ARRAY_BIO.find(b => b.rosTypeId === 11).biography;
                //     let parlServiceBioRecords = ARRAY_BIO.find(b => b.rosTypeId === 9).biography;
                //     let parlServiceDateStart = parlServiceBioRecords[0].record[1];
                //     let parlServiceDateEnd = parlServiceBioRecords[parlServiceBioRecords.length - 1].record[2];
                //     if (partyRepresentation[0].record[1] === '1900-01-01') {
                //         partyRepresentation[0].record[1] = parlServiceDateStart;
                //     }

                //     if (!inCurrentParliament && parlServiceDateEnd != 'undefined'
                //         && (partyRepresentation[partyRepresentation.length - 1].record[2] == 'undefined'
                //         && partyRepresentation[partyRepresentation.length - 1].record[2] == '1900-01-01')) {
                //         partyRepresentation[partyRepresentation.length - 1].record[2] = parlServiceDateEnd;
                //     }

                //     for (let i = 0; i < partyRepresentation.length; i++) {
                //         partyRepresentation[i].record[3] = this.DATE_FROMTO(partyRepresentation[i].record[1], partyRepresentation[i].record[2])
                //     }
                // }

                record = this.STRING_COALESCE(this.FILTERED_PARLIAMENTARIAN.ServiceHistory_Duration, 'Service History: ')
                if (record.length > 0) {
                    parlService = ARRAY_BIO.find(i => i.rosTypeId == 9);
                    if (parlService && parlService.biography) {
                        parlService.biography.push({ id: 1, typeId: 9, record: [record] });
                    }
                }

                if (this.FILTERED_PARLIAMENTARIAN.ElectedSenatorNo > 0) {
                    record = `${this.numberToOrdinal(this.FILTERED_PARLIAMENTARIAN.ElectedSenatorNo)} member of the Senate.`
                    if (record.length > 0) {
                        if (parlService && parlService.biography) {
                            parlService.biography.push({ id: 1, typeId: 9, record: [record] });
                        }
                    }
                }

                if (this.FILTERED_PARLIAMENTARIAN.ElectedMemberNo > 0) {
                    record = `${this.numberToOrdinal(this.FILTERED_PARLIAMENTARIAN.ElectedMemberNo)} member of the House of Representatives.`
                    if (record.length > 0) {
                        if (parlService && parlService.biography) {
                            parlService.biography.push({ id: 1, typeId: 9, record: [record] });
                        }
                    }
                }

                for (let i = 0; i < senateStates.length; i++) {
                    record = `${senateStates[i].record[1]} member of the Senate for ${senateStates[i].record[0]}.`
                    if (record.length > 0) {
                        if (parlService && parlService.biography) {
                            parlService.biography.push({ id: 1, typeId: 9, record: [record] });
                        }
                    }
                }

                for (let i = 0; i < houseElectorates.length; i++) {
                    record = `${houseElectorates[i].record[2]} member of the House of Representatives for ${houseElectorates[i].record[0]}, ${houseElectorates[i].record[1]}.`
                    if (record.length > 0) {
                        if (parlService && parlService.biography) {
                            parlService.biography.push({ id: 1, typeId: 9, record: [record] });
                        }
                    }
                }

                // Birth Details
                record = '';
                if (this.FILTERED_PARLIAMENTARIAN.DateOfBirth || this.FILTERED_PARLIAMENTARIAN.PlaceOfBirth || this.FILTERED_PARLIAMENTARIAN.CountryOfBirth) {
                    record += "Born: ";
                }
                if (this.FILTERED_PARLIAMENTARIAN.DateOfBirth) {
                    record += this.formatDate(this.FILTERED_PARLIAMENTARIAN.DateOfBirth) + ', ';
                }

                if (this.FILTERED_PARLIAMENTARIAN.PlaceOfBirth) {
                    record += this.FILTERED_PARLIAMENTARIAN.PlaceOfBirth + ', ';
                }

                if (this.FILTERED_PARLIAMENTARIAN.CountryOfBirth) {
                    record += this.FILTERED_PARLIAMENTARIAN.CountryOfBirth;
                }

                record = record.trim().trimEndChar(',');
                if (record.length > 0) {
                    personalRecords.biography.push({ id: 1, typeId: 105, record: [record] });
                }

                // Death details
                record = ''
                if (this.FILTERED_PARLIAMENTARIAN.DateOfDeath || this.FILTERED_PARLIAMENTARIAN.PlaceOfDeath) {
                    record += "Died: ";
                }
                if (this.FILTERED_PARLIAMENTARIAN.DateOfDeath) {
                    record += this.formatDate(this.FILTERED_PARLIAMENTARIAN.DateOfDeath) + ', ';
                }

                if (this.FILTERED_PARLIAMENTARIAN.PlaceOfDeath) {
                    record += this.FILTERED_PARLIAMENTARIAN.PlaceOfDeath;
                }

                record = record.trim().trimEndChar(',');
                if (record.length > 0) {
                    personalRecords.biography.push({ id: 1, typeId: 105, record: [record] });
                }
                
                if (this.familyRelationships.length > 0) {                    
                    personalRecords.biography.push(...this.familyRelationships.map(r => ({ id: 1, typeId: 105, record: [`${r.Relationship} of ${r.DisplayName}`, r.Phid , 'Family'] })));                    
                }

                return ARRAY_BIO;
            },

            DATE_FROMTO(DateFrom, DateTo) {
                if (DateFrom && DateFrom != 'undefined' && DateFrom != 'Undefined' && DateFrom != '1900-01-01' && DateFrom != '1900-01-1') {
                    DateFrom = '. Served: ' + this.formatDate(DateFrom);
                    if (DateTo && DateTo != 'undefined' && DateTo != 'Undefined' && DateTo != '1900-01-01' && DateTo != '1900-01-1') {
                        DateTo = ' to ' + this.formatDate(DateTo);
                    } else {
                        DateTo = ' to present';
                    }
                } else {
                    DateFrom = '';
                    DateTo = '';
                }


                return DateFrom + DateTo + '.';
            },

            DATE_COALESCE(date) {
                if (date && date != '1900-01-01' && date != '1900-01-1') {
                    return date;
                } else {
                    return '';
                }
            },

            STRING_COALESCE(STRING, PREFIX) {
                if (!PREFIX)
                    PREFIX = ''
                if (STRING && STRING != 'undefined' && STRING != 'Undefined' && STRING.trim() != '') {
                    STRING = PREFIX + STRING.trim()
                } else {
                    STRING = ''
                }

                return STRING
            },

            GET_PARLIAMENT_FROM_DATES(DateFrom, DateEnd) {
                var thisCommServiceStart = DateFrom && DateFrom != "1900-01-01" && DateFrom != "1900-01-1" ? this.$moment(DateFrom) : null;
                var thisCommServiceEnd = DateEnd && DateEnd != "1900-01-01" && DateEnd != "1900-01-1" ? this.$moment(DateEnd) : null;

                var allParliamentsSorted = this.SORTED_PARLIAMENTS;
                var servedParliaments = [];
                var startParliament = undefined;

                // heavily relies on the sorted list to optimise logic and performances
                for (var i = 0; i < allParliamentsSorted.length; i++) {
                    var parliament = allParliamentsSorted[i];
                    var election = this.$moment(parliament.DateElection);
                    var dissolution = parliament.DateDissolution && parliament.DateDissolution != "1900-01-01" && parliament.DateDissolution != "1900-01-1" ? this.$moment(parliament.DateDissolution) : null;
                    if (!startParliament) {
                        if (thisCommServiceStart && thisCommServiceStart >= election && (!dissolution || thisCommServiceStart < dissolution)) {
                            startParliament = parliament;
                            servedParliaments.push(parliament);
                        }
                    } else {

                        if (!thisCommServiceEnd
                            || (thisCommServiceEnd && dissolution && thisCommServiceEnd <= dissolution)
                            || (thisCommServiceEnd && !dissolution && thisCommServiceEnd >= election)) {
                            servedParliaments.push(parliament);
                        } else {
                            break;
                        }
                    }
                }

                return servedParliaments.map(p => p.PID)[0];

            },

            GET_MINISTRY_FROM_DATES(DateFrom) {
                var thisMService = this.$moment(DateFrom);
                let ministry = this.ministries.find(obj => this.$moment(obj.DateStart) <= thisMService && (!obj.DateEnd || thisMService < this.$moment(obj.DateEnd)));
                if (ministry) {
                    return ministry.MID;
                } else {
                    return null;
                }

            },

            GET_SHADOWMINISTRY_FROM_DATES(DateFrom) {
                var thisSMService = this.$moment(DateFrom);
                let shadowMinistry = this.shadowMinistries.find(obj => this.$moment(obj.DateStart) <= thisSMService && (!obj.DateEnd || thisSMService < this.$moment(obj.DateEnd)));
                if (shadowMinistry) {
                    return shadowMinistry.SMID;
                } else {
                    return null;
                }
            }
        },

        computed: {
            FILTERED_BIOGRAPHY() {
                return this.CREATEBIO([...this.recordsOfService].sort(function (a, b) { if (parseInt(a.OBY) > parseInt(b.OBY)) { return 1 } else { return -1 } }))
            },
            SORTED_PARLIAMENTS() {
                return [...this.$store.state.OBJ_PARLIAMENTS].sort((a, b) => a.PID - b.PID);
            },
            parliamentaryService() {
                return this.recordsOfService.filter(r => r.ROSTypeID === 9);
            }
        },
    }
</script>

<style scoped>
    h2 {
        padding-top: 15px;
    }

    h3 {
        color: #BE8E57;
        font-weight: normal;
        padding: 8px 0px 5px;
    }

    .application a {
        cursor: pointer;
    }

    

    ol, ul {
        padding-left: 24px;
        list-style: none;
    }
</style>
<style>
    .handbook-link_link{
        text-decoration: none;
    } 

    .handbook-link_link:hover {
        text-decoration: underline;
    }
</style>